import mutationQuery from '../../mutations/product/StockTakeStatusMutation.graphql';
import fragment from '../../fragments/product/StockTakeStatusFragment.graphql';
import defaultQuery from '../../queries/product/StockTakeStatusDefaultQuery.graphql';
import instanceQuery from '../../queries/product/StockTakeStatusQuery.graphql';
import workspaceQuery from '../../queries/product/StockTakeStatusWorkspaceQuery.graphql';
import listQuery from '../../queries/product/StockTakeStatusListQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const StockTakeStatus: EntityType = {
  type: 'StockTakeStatus',
  title: 'Stock Take Status',
  formTitle: 'Stock Take Status',
  formUrl: '/Products/StockControl/StockTakeStatus/Details/',
  workspaceUrl: '/Products/StockControl/StockTakeStatus/Workspace/',
  update: mutationQuery,
  fragment,
  instance: instanceQuery,
  default: defaultQuery,
  workspace: workspaceQuery,
  screenReference: 'STOCK_TAKE_STATUS',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'reference',
    preLoad: true,
  },
};

export default StockTakeStatus;
